import { SubjectPermissionTablePagination } from './SubjectPermissionTablePagination';
export default SubjectPermissionTablePagination;